<template>
  <div class="category-wrapper">

    <add-product-sidebar v-if="sidebarData" :isSidebarActive="productSidebar" @closeSidebar="toggleProductSidebar" :data-prop="sidebarData" />

    <div class="category-toggle">
      <!-- CLICKABLE AREA-->
      <div class="clickable" @click="showProducts = !showProducts">
        <div class="category-name">
          <h3>{{ label }}</h3>
          <p v-if="desc">{{ desc }}</p>
        </div>
        <div class="toggle-icon" :class="(showProducts) ? 'rotate' : ''"><span><i class="fas fa-caret-right"></i></span></div>
      </div>
      <!-- CLICKABLE AREA END-->
      <div class="category-items" :class="(showProducts) ? 'show' : ''">
        <!-- BURAYA URUNLER GELECEK-->
        <template v-if="products">
          <div class="trproductcontainer">
            <div class="trproductitem" v-for="(item) in products" :key="item.id">

              <item-grid-view :item="item" @click="additemInCart(item)" :ref="`product${item.id}`">

                <!-- SLOT: ACTION BUTTONS -->
                <template slot="action-buttons">
                  <div class="flex flex-wrap buttons-wrapper">
                    <!-- SECONDARY BUTTON: ADD-TO/VIEW-IN CART -->
                    <div
                      class="item-view-secondary-action-btn flex flex-grow items-center justify-center text-danger cursor-pointer">
                      <span class="text-lg font-semibold ml-2">${{formatPrice((item.price !== 0) ? item.price : (item.size !== null) ? item.size.items[0].price : 0)}}</span>
                    </div>
                  </div>
                </template>
              </item-grid-view>

            </div>
          </div>
        </template>
        <!-- ^^BURAYA URUNLER GELECEK^^-->
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'accordion-catering-product-wrapper',
  props: {
    label: {
      type: String
    },
    desc: {
      type: String
    },
    isOpen: Number,
    product_id: String,
    products: {
      type: Array,
      required: true
    }
  },
  mounted () {

    this.checkViewProduct()
    window.onpopstate = () => {
      setTimeout(() => {
        location.reload()
      }, 500)
    }
  },
  data () {
    return {
      productSidebar: false,
      showProducts: false,
      sidebarData: null,
      viewProductId: null
    }
  },
  watch: {
    product_id () {
      this.checkViewProduct()
    }
  },
  components: {
    ItemGridView: () => import('../../products/components/ItemGridView.vue'),
    ItemListView: () => import('../../products/components/ItemListView.vue'),
    AddProductSidebar: () => import('../../products/AddProductSidebar')
  },
  computed: {},
  methods: {
    onBackButton () {
      this.toggleProductSidebar(false)
    },
    openConfirm () {
      this.$vs.dialog({
        type:'alert',
        color: 'green',
        buttonCancel: true,
        title: 'Online Ordering Unavailable',
        acceptText: 'I Understand',
        text: 'We\'re sorry, but currently, this restaurant is not able to accept online orders. Please check back with us soon for updates.'
      })
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    toggleProductSidebar (val = false) {
      this.productSidebar = val
    },
    checkViewProduct () {
      if (this.product_id) {
        const productToShow = this.products.filter(x => { return x.id === parseInt(this.product_id) })
        if (productToShow.length > 0) {
          this.additemInCart(productToShow[0])
        }
      }
    },
    additemInCart (item) {

      if (this.isOpen === 1) {
        if (item.size) {
          const selected_size = item.size.items[0]
          let name = selected_size.name
          if (selected_size.price !== '0') {
            name = name.concat(' - $').concat(selected_size.price)
          }
          item.size.selected_value = {label: name, value: selected_size.id, price: selected_size.price}
        }
        if (!item.quantity) {
          item.quantity = 1
        }
        this.sidebarData = item
        setTimeout(() => {
          this.toggleProductSidebar(true)
        }, 300)
      } else {
        this.openConfirm()
      }
    }
  }
}
</script>

<style lang="scss">
.vs-dialog-green .vs-dialog-text{
  max-width: 100%;
}
.vs-dialog-cancel {
  display:none;
}
.items-grid-view {
  padding: 20px 0 !important;

.col-padding {
  padding-left: 0;
  padding-right:10px;
}
}
.mobile .col-padding {
  padding: 0 ;
}
.item-example {
  width:100%;
  height: 100px;
  background:red;
}
.clickable{
  display:flex;
  justify-content: space-between;
  align-items:center;
  font-weight:bold;
  font-size:24px;
  cursor:pointer;
  padding:10px;
  transition: all 0.1s ease-in;
  border-bottom:1px solid #ccc;
}
.clickable:hover {
  background-color:#f2f2f2;
}
.category-items {
  display:none;

  transition:all 0.3s ease-in;
}
.show{
  display:block;
}
.toggle-icon{

  transition:all .2s ease;
}
.rotate{
  transform:rotate(90deg);
}
.category-name {
  p {
    font-size: 14px;
    font-weight: lighter;
  }
}
@media (max-width:340px){
.category-name {
  p {
    font-size: 12px;
    padding-right:10px
  }
}
}
</style>
